import axiosInstance from "services/AxiosInstance";
import { ResponseType, TQuestionnaireRequest } from "types";

export const postQuestionnaireRequestApproveService = async (
  questionnaireRequestId: string
): Promise<ResponseType<TQuestionnaireRequest>> => {
  const response = await axiosInstance.post(`questionnaire/request/${questionnaireRequestId}/approval`);
  return response.data;
};
